module.exports = __webpack_public_path__ + "static/media/table-active.166b4dd9.svg";